export default {
    computed: {
        tableFilter() {
            return this.$store.getters['table/getFilter'];
        },
        tableFilters() {
            return this.$store.getters['table/getFilters'];
        },
        selectedFilters() {
            return this.$store.getters['table/getSelectedFilters'];
        },
        selectedFiltersCount() {
            return this.selectedFilters.length;
        },
        startDate: {
            set(value) {
                let object = {key: 'start', value: value};
                this.$store.dispatch('table/updateDates', object);
            },
            get() {
                return this.$store.getters['table/getStartDate'];
            }
        },
        endDate: {
            set(value) {
                let object = {key: 'end', value: value};
                this.$store.dispatch('table/updateDates', object);
            },
            get() {
                return this.$store.getters['table/getEndDate'];
            }
        },
        searchQuery: {
            set(value) {
                this.$store.dispatch('table/updateSearchQuery', value);
            },
            get() {
                return this.$store.getters['table/getSearchQuery'];
            }
        }
    },

    methods: {
        toggleFilterParent(filter) {
            this.$store.dispatch('table/toggleFilterParent', filter);
        },
        toggleFilter(filterId, filter) {
            this.$store.dispatch('table/toggleFilterItem', {
                id: filterId,
                key: filter
            });
        },
        showFilterChildren(filter) {
            return this.$store.getters['table/getFilterParentExpanded'](filter);
        },
        filterActive(filterId, filter) {
            return this.$store.getters['table/getFilterSelected'](filter, filterId);
        },
        resetFilters() {
            this.$store.dispatch('table/resetFilters');
        },
    },

};
